var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgIcon } from '@mui/material';
var SuccessCheckIcon = function (props) {
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 48 48" }),
        React.createElement("circle", { cx: "24", cy: "24", r: "24", fill: "#E6F4EA" }),
        React.createElement("path", { d: "M14 24L21 31L34 18", stroke: "#38A169", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));
};
export default SuccessCheckIcon;
